export default `<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 18 18"
  height="18"
  width="18"
>
  <g
    transform="matrix(0.03156322,0,0,0.03156322,3.5170168,-8.314699)"
  >
    <path
      d="m 340,548.571 q 0,7.429 -5.714,13.143 L 68,828 q -5.714,5.714 -13.143,5.714 -7.429,0 -13.143,-5.714 L 13.143,799.429 q -5.714,-5.714 -5.714,-13.143 0,-7.429 5.714,-13.143 L 237.714,548.572 13.143,324.001 q -5.714,-5.714 -5.714,-13.143 0,-7.429 5.714,-13.143 l 28.571,-28.571 q 5.714,-5.714 13.143,-5.714 7.429,0 13.143,5.714 L 334.286,535.43 Q 340,541.144 340,548.573 Z"
    />
  </g>
</svg>`;
